import React from 'react';
import styled from 'styled-components';
import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
import qrCodeUrl from '../assets/qr-code.png';

const Footer = () => {
  return (
    <FooterSection id="contact">
      <Container>
        <FooterContent>
          <ContactInfo>
            <h3>Connect with the MindBridge Team</h3>
            <p>We're passionate about youth mental health. Let's talk.</p>
            <SocialLinks>
              <a href="#" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
              <a href="#" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
              <a href="mailto:hello@mindbridge.com"><FaEnvelope /></a>
            </SocialLinks>
          </ContactInfo>
          <QRCodeWrapper>
            <QRCode src={qrCodeUrl} alt="Scan to Connect" />
            <QRCodeText>Scan to Connect & Try MindBridge</QRCodeText>
          </QRCodeWrapper>
        </FooterContent>
        <Copyright>
          &copy; Ivy 2025 Hackathon - MindBridge Team
        </Copyright>
      </Container>
    </FooterSection>
  );
};

export default Footer;

const FooterSection = styled.footer`
  background-color: var(--primary-blue-dark);
  color: var(--text-light);
  padding: 4rem 0 2rem 0;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 3rem;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ContactInfo = styled.div`
  text-align: left;

  h3 {
    font-size: 1.8rem;
    margin: 0 0 1rem 0;
  }

  p {
    font-size: 1.1rem;
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const SocialLinks = styled.div`
  margin-top: 1.5rem;
  
  a {
    color: var(--text-light);
    font-size: 2rem;
    margin-right: 1.5rem;
    transition: color 0.3s ease;
  }

  a:hover {
    color: var(--secondary-green);
  }
`;

const QRCodeWrapper = styled.div`
  text-align: center;
  width: 120px; /* Control the size of the QR code via its wrapper */
  margin: 0 auto;
  padding: 0;
  display: block;
`;

const QRCode = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  background: white;
  padding: 5px;
  display: block;
  margin: 0 auto;
  box-sizing: border-box;
`;

const QRCodeText = styled.p`
  font-size: 0.9rem;
  margin-top: 0.5rem;
  opacity: 0.9;
`;

const Copyright = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 2rem;
  font-size: 0.9rem;
  opacity: 0.7;
`;
